import React, { useCallback, useState } from 'react';
import { useFormik } from 'formik';
import { updateKnowledgeLink } from 'shared/store/actions/knowledge.items.actions';
import { useDispatch, useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { MultipleOwnersSelector } from 'src/components/owners/owners-selector/multiple-owners-selector';
import { Modal } from 'src/components/design-system';

const KnowledgeLinkUpdatePopup = ({ open = false, entity, linkOwnerIds, onDismiss }) => {
  const [isLoading, setIsLoading] = useState(false);
  const lang = useSelector(getLang('KNOWLEDGE_LINK_EDITOR'));
  const dispatch = useDispatch();

  const onSubmit = useCallback(
    async ({ linkOwnerIds }) => {
      setIsLoading(true);

      await dispatch(updateKnowledgeLink({ ...entity, linkOwnerIds }));

      setIsLoading(false);
      onDismiss();
    },
    [onDismiss, entity, dispatch],
  );
  const { handleSubmit, setFieldValue, values, errors } = useFormik({
    enableReinitialize: true,
    initialValues: {
      linkOwnerIds,
    },
    onSubmit,
  });

  return (
    <Modal
      title={lang.UPDATE_TITLE}
      open={open}
      onCancel={onDismiss}
      onSubmit={handleSubmit}
      cancelText={lang.DISMISS}
      submitText={lang.UPDATE}
      loading={isLoading}
      submitDisabled={isLoading}>
      <form onSubmit={handleSubmit}>
        <label>{lang.OWNER}</label>
        <MultipleOwnersSelector
          value={values.linkOwnerIds}
          error={errors.linkOwnerIds}
          placeholder={lang.OWNER_PLACEHOLDER}
          name="linkOwnerIds"
          onChange={setFieldValue}
          borderRadius={4}
        />
      </form>
    </Modal>
  );
};

export { KnowledgeLinkUpdatePopup };
